import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/UserContext';
import AuthComponent from './components/Auth';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Account from './components/Account';
import MCQs from './components/questions/MCQs';
import TrueFalse from './components/questions/TrueFalse';
import ShortAnswer from './components/questions/ShortAnswer';
import FillInTheBlank from './components/questions/FillInTheBlank';
import Matching from './components/questions/Matching';
import Essay from './components/questions/Essay';
import RankingOrdering from './components/questions/RankingOrdering';
import NumericalResponse from './components/questions/NumericalResponse';
import './App.css';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<AuthComponent />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /></ProtectedRoute>}/>
          <Route path="/multi-choice" element={<ProtectedRoute><MCQs /></ProtectedRoute>} />
          <Route path="/true-or-false" element={<ProtectedRoute><TrueFalse /></ProtectedRoute>} />
          <Route path="/short-answer" element={<ProtectedRoute><ShortAnswer /></ProtectedRoute>} />
          <Route path="/fill-in-the-blank" element={<ProtectedRoute><FillInTheBlank /></ProtectedRoute>} />
          <Route path="/matching" element={<ProtectedRoute><Matching /></ProtectedRoute>} />
          <Route path="/essay" element={<ProtectedRoute><Essay /></ProtectedRoute>} />
          <Route path="/ranking-ordering" element={<ProtectedRoute><RankingOrdering /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account/></ProtectedRoute>} />
          <Route path="/numerical-response" element={<ProtectedRoute><NumericalResponse /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <div>
                  <h1>Profile Page</h1>
                  <p>This is a protected inner page.</p>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
